import { BillingApi, Configuration } from '@/api';
import { BillingCustomerTarget, BillingDetails } from '@/models/Billing';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export const getBillingDetailsQueryKey = ['billing-details'];

const useGetBillingDetailsQuery = (customer?: BillingCustomerTarget) => {
  const queryClient = useQueryClient();

  const billingApi = new BillingApi(new Configuration(useAuth));

  const {
    data: billingDetails,
    isLoading,
    isFetching,
    error,
    refetch,
  } = useQuery<BillingDetails | undefined>({
    queryKey: [getBillingDetailsQueryKey[0], customer ?? null],
    queryFn: () => billingApi.getBillingDetails(customer),
  });

  const invalidateQuery = async () => {
    await queryClient.invalidateQueries({
      queryKey: [getBillingDetailsQueryKey[0], customer ?? null],
    });
  };

  return {
    billingDetails,
    isLoading,
    isFetching,
    error,
    refetch,
    invalidateQuery,
  };
};

export default useGetBillingDetailsQuery;
